import { z } from 'zod'

const ServiceAccountKey = z.object({
  project_id: z.string().trim().min(1),
  client_email: z.string().trim().min(1),
  private_key: z.string().min(1),
})

export type ServiceAccountFields = { projectId: string; clientEmail: string; privateKey: string }

const parseJson = (text: string): unknown => {
  try {
    return JSON.parse(text)
  } catch {
    return null
  }
}

export const readServiceAccountKey = (text: string): ServiceAccountFields | null => {
  const parsed = ServiceAccountKey.safeParse(parseJson(text))
  if (!parsed.success) return null
  return {
    projectId: parsed.data.project_id,
    clientEmail: parsed.data.client_email,
    privateKey: parsed.data.private_key,
  }
}
